import PropTypes from "prop-types";
import {
  BarChart as REBarChart,
  Bar,
  XAxis,
  ResponsiveContainer,
  Cell,
  YAxis,
  Tooltip,
  CartesianGrid,
  ReferenceLine,
} from "recharts";
import { Legend } from "recharts";

export const BarChart = ({
  data = [],
  tooltipContent,
  xAxisProps,
  yAxisProps,
  barDataKey,
  bar2DataKey,
  barChartProps,
  barProps,
  cartesianGridProps,
  referenceLineProps,
  legendProps,
}) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <REBarChart
        height={300}
        data={data}
        barGap={1}
        barCategoryGap={1}
        {...barChartProps}
      >
        {legendProps && <Legend {...legendProps} />}
        {xAxisProps && <XAxis {...xAxisProps} />}

        {yAxisProps && <YAxis {...yAxisProps} />}

        {cartesianGridProps && (
          <CartesianGrid vertical={false} {...cartesianGridProps} />
        )}

        {referenceLineProps && <ReferenceLine y={0} {...referenceLineProps} />}

        {/* tooltip */}
        {tooltipContent && (
          <Tooltip cursor={{ fill: "transparent" }} content={tooltipContent} />
        )}

        <Bar dataKey={barDataKey} barSize={20} {...barProps}>
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={entry.color}
              radius={[4, 4, 2, 2]}
            />
          ))}
        </Bar>

        {bar2DataKey && (
          <Bar dataKey={bar2DataKey} barSize={20} {...barProps}>
            {data.map((entry, index) => {
              return (
                <Cell
                  key={`cell2-${index}`}
                  fill={entry.color2}
                  radius={[4, 4, 2, 2]}
                />
              );
            })}
          </Bar>
        )}
      </REBarChart>
    </ResponsiveContainer>
  );
};

BarChart.propTypes = {
  data: PropTypes.array,
  tooltipContent: PropTypes.func,
  xAxisProps: PropTypes.object,
  yAxisProps: PropTypes.object,
  barDataKey: PropTypes.string,
  bar2DataKey: PropTypes.string,
  barChartProps: PropTypes.object,
  barProps: PropTypes.object,
  cartesianGridProps: PropTypes.object,
  referenceLineProps: PropTypes.object,
  legendProps: PropTypes.object,
};
